import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-irrigator-access-overlays',
  templateUrl: './irrigator-access-overlays.component.html',
  styleUrl: './irrigator-access-overlays.component.scss'
})
export class IrrigatorAccessOverlaysComponent {
  @Output() parcelsPanelRequested = new EventEmitter<void>();
}
